import EntityModel from '@/common/models/entity-model';
import CreditMemoAllocationItemModel from '@/common/models/credit-memo-allocation-item';

export default class CreditMemoAllocationModel extends EntityModel {
    hydrate({
        invoiceId = null,
        credit = null,
        items = [],
    } = {}) {
        this.invoiceId = invoiceId;
        this.credit = credit;
        this.items = items.map(item => new CreditMemoAllocationItemModel(item));
    }
}
